import React from 'react';

import HowToReturn from '../HowToReturn';
import XfinityStore from '../svgs/XfinityStore';

const StoreMethodContent = () => (
  <div className="return-method card-group">
    <div className="card-group__item">
      <div className="card">
        <div className="card__content">
          <div>
            <p className="body3">
              Check the status and hours of locations near you.&nbsp;
              <a href="https://www.xfinity.com/support/service-center-locations?retail=true" rel="noopener noreferrer" target="_blank">
                Find an Xfinity Store
              </a>
            </p>
          </div>
          <div>
            <XfinityStore className="svg-icon--185-wide" />
          </div>
        </div>
      </div>
    </div>
    <HowToReturn hideTitle context="xfinityStore" />
    <div className="card-group__item">
      <div className="card card--secondary">
        <div className="card__content">
          <div className="hgroup">
            <p className="body2">Did you recently move out of state?</p>
            <p className="body3">
              {'If you\'re returning equipment from a different state, we recommend you complete this process at a UPS Store.'}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default StoreMethodContent;
